export var createCustomUrl = function createCustomUrl(category, subcategory) {
  if (!category || !subcategory) {
    return null;
  }
  return "/blog-da-lu/s/".concat(category.categoryId, "/").concat(subcategory.categoryId, "/").concat(subcategory.slug, "/").concat(subcategory.id).toLocaleLowerCase();
};